import script from "./SelecaoProdutoEstoqueModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SelecaoProdutoEstoqueModal.vue?vue&type=script&setup=true&lang=js"

import "./SelecaoProdutoEstoqueModal.vue?vue&type=style&index=0&id=af9884fa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af9884fa"]])

export default __exports__